import Component from '../abstracts/Component';
import TrackingComponent from "../components/TrackingComponent";

export default class SocialLoginComponent extends Component {

  get SELECTORS() {
    return {
        facebookbutton: '.facebook-login-button',
        googlebutton: '.google-login-button',
        facebookSignup: '.facebook-signup-button',
        googleSignup: '.google-signup-button'
    };
  }

  constructor() {
    super();
    this.trackingComponent = new TrackingComponent();
  }


  googleLoginMobile(e) {
    let ctx = this
    $.getScript('https://apis.google.com/js/client:platform.js', function(){
                  $.ajax({
                      method: 'GET',
                      url: '/action/social-login/mobile-login-url/google?email=',
                      dataType: "json",
                      success: function( data ) {
                          if (data === 'error'){
                            window.location = "/error";
                          }else {

                            var redirectUrl = "https://accounts.google.com/o/oauth2/v2/auth?" +
                              "scope=profile%20email&" +
                              "access_type=offline&" +
                              "include_granted_scopes=true&" +
                              "response_type=code&" +
                              "redirect_uri=" + data.redirect + "/action/social-login/mobile-login/google&" +
                              "client_id=" + data.clientId ;

                            console.log("Redirect to " + redirectUrl);
                            window.location.href = redirectUrl;
                            let params = { loginType : e.currentTarget.dataset.loginType };
                            ctx.trackingComponent.actions.login(params);
                          }
                      }
                  });
               });
  }

  googleLoginDesktop(e) {
     let ctx = this
     $.getScript('https://apis.google.com/js/client:platform.js', function(){
              $.ajax({
                  method: 'GET',
                  url: '/action/social-login/login-url/google?email=',
                  success: function( data ) {
                      if (data === 'error'){
                        window.location = "/error";
                      }else {
                        gapi.load('auth2', function(){
                                // Retrieve the singleton for the GoogleAuth library and set up the client.
                          var auth2 = gapi.auth2.init({
                            client_id: data,
                            cookiepolicy: 'single_host_origin',
                            scope: 'profile email',
                            ux_mode: 'redirect'
                          });
                          console.log('Welcome!  Fetching your information.... ');
                          auth2.grantOfflineAccess().then(function(authResult) {
                            if(authResult['code']) {
                              $("#login-google-form").append('<input type="hidden" name="code" value="'+authResult['code']+'" /> ');
                              $("#login-google-form").submit();
                              let params = { loginType : e.currentTarget.dataset.loginType };
                              ctx.trackingComponent.actions.login(params);
                            }
                          });
                        });
                      }
                  }
              });
           });
  }


googleSignupDesktop() {

 $.getScript('https://apis.google.com/js/client:platform.js', function(){
        $.ajax({
          method: 'GET',
          url: '/action/social-login/login-url/google?email=',
          success: function( data ) {
            if (data === 'error'){
              window.location = "/error";
            }else {
              gapi.load('auth2', function(){
                      // Retrieve the singleton for the GoogleAuth library and set up the client.
                var auth2 = gapi.auth2.init({
                  client_id: data,
                  cookiepolicy: 'single_host_origin',
                  scope: 'profile email',
                  ux_mode: 'redirect',
                  redirect_uri: 'https://it-mm.dev.digitalcoat.org:9002/action/social-login/social/google'
                });
                console.log('Welcome!  Fetching your information.... ');
                auth2.grantOfflineAccess().then(function(authResult) {
                  if(authResult['code']) {
                    var email = $("#email").val()
                    if ( $("#social_reg_checkout").val() !== 'true'){
                      email = "";
                    }
                    $("#signup-google-form").append('<input type="hidden" name="code" value="'+authResult['code']+'" /> ');
                    $("#signup-google-form").append('<input type="hidden" name="email" value="'+email+'" /> ');
                    $("#signup-google-form").submit();
                  }
                });
              });
            }
          }
        });
      });
}


  bindEvents() {
    let ctx = this;
    $('body').on('click', this.SELECTORS.facebookbutton, function (e) {
       e.preventDefault();
       console.log('Welcome!  Fetching your information.... ');

        $.ajax({
            method: 'GET',
            url: '/action/social-login/login-url/facebook?email=',
            success: function( data ) {
                if (data === 'error'){
                  window.location = "/error"
                }else {
                  window.location = data;
                  let params = { loginType : e.currentTarget.dataset.loginType };
                  ctx.trackingComponent.actions.login(params);
                }
            }
        });
      });

    $('body').on('click', this.SELECTORS.facebookSignup, function (e) {
      e.preventDefault();
         console.log('Welcome!  Fetching your information.... ');
         var email = $("#email").val()
          if ( $("#social_reg_checkout").val() !== 'true'){
            email = "";
          }

          $.ajax({
              method: 'GET',
              url: '/action/social-login/login-url/facebook?email='+email,
              success: function( data ) {
                  if (data === 'error'){
                    window.location = '/error';
                  }else {
                    window.location = data;
                  }
              }
          });
      });

    $('body').on('click', this.SELECTORS.googlebutton, function (e) {
      e.preventDefault();
      let isMobile = window.matchMedia('(max-width:820px)').matches;
      if(isMobile) {
        ctx.googleLoginMobile(e);
      }
      else {
        ctx.googleLoginDesktop(e);
      }
    });


    $('body').on('click', this.SELECTORS.googleSignup, function (e) {
     e.preventDefault();
          let isMobile = window.matchMedia('(max-width:820px)').matches;
          if(isMobile) {
            ctx.googleLoginMobile();
          }
          else {
            ctx.googleSignupDesktop();
          }
    });

  }

  render() {

    this.bindEvents();
  }
}
